import { render, staticRenderFns } from "./VehicleAmount.vue?vue&type=template&id=825d79ce&"
import script from "./VehicleAmount.vue?vue&type=script&lang=ts&"
export * from "./VehicleAmount.vue?vue&type=script&lang=ts&"
import style0 from "./VehicleAmount.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports